import { useEffect, useState } from "react";

import { DYNAMIC_FETCH_THRESHOLD } from "appConfig";

import { getQuickList } from "services/sosInventoryService/sosApi";
import { handleProgramError } from "services/utility/errors";

import { OBJECT_TYPES } from "appConstants";

const CLASS_OBJECT_TYPE = OBJECT_TYPES.CLASS.fullString;

/**
 * @name    useClasses
 *
 * @summary retrieves class records for use in transaction forms; mirrors the
 *          shape of useItems so callers can drive dynamic-fetch behaviour in
 *          the same way
 *
 * @param   reGet (any value) - when reGet changes the class list will be
 *          re-fetched from the API; increment an integer each time a re-get
 *          is desired (e.g. after a quick-add)
 *
 * @returns { classes, classesCount } - classes is an array of class records
 *          with fullName mapped to name; classesCount is the *total* number
 *          of class records in the database (not necessarily the length of
 *          the returned array)
 */
export function useClasses() {
  const [data, setData] = useState({ classes: null, classesCount: null });

  useEffect(() => {
    async function retrieveRecords() {
      const response = await getQuickList(CLASS_OBJECT_TYPE, {
        inTransaction: true,
        maxresults: DYNAMIC_FETCH_THRESHOLD,
      });
      if (response) {
        const classes = response.data.map(({ id, fullName }) => ({
          id,
          name: fullName,
        }));
        setData({ classes, classesCount: response.totalCount });
      } else {
        handleProgramError(
          new Error(`useClasses | unsuccessful call to getQuickList`)
        );
      }
    }
    retrieveRecords();
  }, []);

  return data;
}
